import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CardTable from "Components/CardTable";
import Discussion from "Components/Discussion";
import Question from "Components/Question";
import Score from "Components/Score";
import { getGameSettings } from "util/supabase";
import { getPlayerId } from "util/utils";
import { useSupabasePostgresSubscription } from "util/useSupabsePostgresSubscription";

const Game = () => {
  const { gameId } = useParams();
  const playerId = getPlayerId();
  const [gameSettings, setGameSettings] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!gameSettings) {
      getGameSettings(gameId).then((settings) => {
        if (
          !settings ||
          !settings?.players?.find((item) => item.id === playerId)
        ) {
          navigate("/lobby");
        }

        setGameSettings(settings);
      });
    }
  }, [gameId, navigate, playerId, gameSettings]);

  useSupabasePostgresSubscription({
    events: [
      {
        event: "UPDATE",
        table: "players",
        filter: `session_id=eq.${gameId}`,
        callback: (payload) => {
          getGameSettings(gameId).then(setGameSettings);
        },
      },
      {
        event: "UPDATE",
        table: "sessions",
        filter: `id=eq.${gameId}`,
        callback: (payload) => {
          getGameSettings(gameId).then(setGameSettings);
        },
      },
    ],
  });

  const currentPlayer = useMemo(
    () => gameSettings?.players?.find((item) => item.id === playerId),
    [gameSettings?.players, playerId],
  );

  switch (gameSettings?.stage) {
    case "DISCUSSION":
      return (
        <Discussion gameSettings={gameSettings} currentPlayer={currentPlayer} />
      );
    case "GAME":
      return (
        <CardTable gameSettings={gameSettings} currentPlayer={currentPlayer} />
      );
    case "END_QUESTION":
      return (
        <Question gameSettings={gameSettings} currentPlayer={currentPlayer} />
      );
    case "SCORE":
      return (
        <Score gameSettings={gameSettings} currentPlayer={currentPlayer} />
      );
    default:
      return null;
  }
};

export default Game;
